export default "__VITE_ASSET__DOmkXha4__"